/**
 * c2-mega-dropdown.js
 * Desktop: click-to-open dropdowns (overrides theme's hover behavior).
 * Mobile: drill-in navigation with slide subviews.
 */
(function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 1200px)');
  var ACTIVE_CLASS = 'c2-nav-mobile__subview--active';
  var CLICK_OPEN_CLASS = 'c2-click-opened';

  function init() {
    initDesktopClick();
    initMobileDrillIn();
  }

  /* ==== Desktop click-to-open ==== */

  function initDesktopClick() {
    var nav = document.querySelector('.c2-nav');
    if (!nav) return;

    var parentLinks = nav.querySelectorAll('.wt-page-nav-mega__link--parent');

    for (var i = 0; i < parentLinks.length; i++) {
      (function (link) {
        link.addEventListener('click', function (e) {
          if (!DESKTOP_MQ.matches) return;

          e.preventDefault();
          e.stopImmediatePropagation();

          var item = link.closest('.c2-nav__item');
          if (!item) return;

          var wasOpen = item.classList.contains(CLICK_OPEN_CLASS);

          // Close all open items
          closeAllDesktop(nav);

          // Toggle clicked item
          if (!wasOpen) {
            item.classList.add(CLICK_OPEN_CLASS);
            link.setAttribute('aria-expanded', 'true');
          }
        }, true);
      })(parentLinks[i]);
    }

    // Close on click outside
    document.addEventListener('click', function (e) {
      if (!DESKTOP_MQ.matches) return;
      if (!e.target.closest('.c2-nav')) {
        closeAllDesktop(nav);
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeAllDesktop(nav);
      }
    });
  }

  function closeAllDesktop(nav) {
    if (!nav) nav = document.querySelector('.c2-nav');
    if (!nav) return;
    var openItems = nav.querySelectorAll('.' + CLICK_OPEN_CLASS);
    for (var i = 0; i < openItems.length; i++) {
      openItems[i].classList.remove(CLICK_OPEN_CLASS);
      var link = openItems[i].querySelector('[aria-expanded]');
      if (link) link.setAttribute('aria-expanded', 'false');
    }
  }

  /* ==== Mobile drill-in ==== */

  function initMobileDrillIn() {
    var container = document.querySelector('.c2-nav-mobile');
    if (!container) return;

    var triggers = container.querySelectorAll('[data-c2-drill-target]');
    var backButtons = container.querySelectorAll('[data-c2-back]');

    for (var i = 0; i < triggers.length; i++) {
      (function (trigger) {
        trigger.addEventListener('click', function (e) {
          if (DESKTOP_MQ.matches) return;

          e.preventDefault();
          e.stopImmediatePropagation();

          var targetId = trigger.getAttribute('data-c2-drill-target');
          var subview = container.querySelector('[data-c2-subview="' + targetId + '"]');
          if (!subview) return;

          container.setAttribute('data-c2-drilled', targetId);

          subview.hidden = false;
          void subview.offsetHeight;
          subview.classList.add(ACTIVE_CLASS);

          var backBtn = subview.querySelector('[data-c2-back]');
          if (backBtn) backBtn.focus();
        }, true);
      })(triggers[i]);
    }

    for (var j = 0; j < backButtons.length; j++) {
      backButtons[j].addEventListener('click', function () {
        resetDrillIn(container);
      });
    }

    // Reset when drawer closes
    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        if (mutations[m].attributeName === 'class') {
          if (!document.body.classList.contains('menu-open')) {
            resetDrillIn(container);
          }
        }
      }
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function resetDrillIn(container) {
    if (!container) return;

    container.removeAttribute('data-c2-drilled');

    var activeSubviews = container.querySelectorAll('.' + ACTIVE_CLASS);
    for (var k = 0; k < activeSubviews.length; k++) {
      activeSubviews[k].classList.remove(ACTIVE_CLASS);
      activeSubviews[k].hidden = true;
    }
  }

  /* ---- Bootstrap ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
